export interface Review {
  name: string
  category: string
  quote: string
}

export const reviews: Review[] = [
  {
    name: 'Sarah Donovan',
    category: 'Auto glass',
    quote:
      'Repaired my windshield chip for much less than competitors. Little to no hassle and they got me in as soon as I called.',
  },
  {
    name: 'Julie Kusey',
    category: 'Shower doors',
    quote:
      'We had our shower door replaced by Kosin’s… The quality of work was superb.',
  },
  {
    name: 'Robert Hutchison',
    category: 'Commercial glass',
    quote: 'They were honest, I thought we needed two windows…',
  },
]
